import Link from "next/link";

export default function FooterCom() {
  return (
    <div>
     
      <div className="footer-container" data-area="footer">
        <div className={"foot_div"}>
          {/* <span className="text">
            © Powered by<Link href={"https://fabboxstudios.com/"} prefetch={false} target={"_blank"} className="text">
              Fabbox Studios
          </Link>
          </span> */}
           <span className="text">
            © Powered by Fabbox Studios
          </span>
        </div >
        <div className={"foot_div"}>
          <Link href={"/our-partners"} prefetch={false} className="footer-text text" passHref>
            Our Partners
          </Link >
          <Link href={"/free-games-for-your-site"} prefetch={false} className="footer-text text" passHref>
            Free Games
          </Link>
          <Link href={"/contact-us"} prefetch={false} className="footer-text text" passHref>
            Contact us
          </Link>
          <Link href={"/privacy-policy"} prefetch={false} className="footer-text text" passHref>
            Privacy Policy
          </Link>
          {/* <Link href={"/blog"} prefetch={false} className="footer-text text">
            Blog
          </Link> */}
        </div>
      </div>
    </div>
  );
}
